var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 100",
    style: {
      enableBackground: "new 0 0 134 100"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFF200;}\n\t.st2{fill:#00A5E3;}\n\t.st3{fill:#FF401B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,99.5H125c4.4,0,8-3.6,8-8V68.1V33.5v-9.8V8.5c0-4.4-3.6-8-8-8H76.6H52.7H9c-4.4,0-8,3.6-8,8v6.1v19v34.6v23.4 C1.1,95.9,4.6,99.5,9,99.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.7,64.5c-4.2-5.6-4.2-14.5,0-20.8c4.4-6.7,12.5-9.8,20.3-7.9c8.3,2.1,12.9,9.1,13.7,14.1 C46.4,54.8,35.1,59.6,23.7,64.5z M47.7,47c-3.5-4.1-9.5-5.1-14-2.3c-3.7,2.2-6.3,7.5-5.1,10.4C35,52.5,41.3,49.8,47.7,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,65.8c-1,2.5-2,4.8-3,7.3c-2.4-1-4.8-1.9-7.1-3.1c-1.9-0.9-2.9-2.7-3.3-4.7c-0.1-0.8-0.2-1.6-0.2-2.4 c0-11.7,0-23.3,0-35c0-0.3,0-0.6,0.1-1c2.4,0,4.8,0,7.3,0c0,0.5,0,0.9,0,1.4c0,11.2,0,22.4,0,33.6c0,0.9,0.2,1.4,1.1,1.7 C71.3,64.3,73,65,74.8,65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.1,50.3c-2.6,0.5-5.1,1-7.5,1.5c-3.3-7.6-6.9-9.6-14.6-8.3c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.8-2.2-1.5-4.4-2.4-6.7c4.8-1.6,9.5-1.5,14,0.6C108.1,39.6,111.6,44.1,113.1,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.3,40.2c1.7,1.9,3.3,3.7,5,5.6c-5.2,5.6-4.8,11.2,0,16.8c-1.6,1.9-3.2,3.8-4.9,5.7 C73.9,61.4,73.6,47.4,82.3,40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.9,62.2c2,1.8,3.9,3.5,5.8,5.2C46.8,73.9,36,74.7,29.4,70c1.3-2.1,2.7-4.3,4.1-6.5 c2.2,1.3,4.6,1.9,7.1,1.6C43.1,64.9,45.3,63.8,46.9,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.9,71.6c0.9-2.5,1.7-4.9,2.5-7.2c8.2,1,11.7-1.1,14.5-8.4c0.2,0,0.3,0,0.5,0c2.3,0.4,4.6,0.9,7,1.4 c-1,5-3.5,9-7.6,11.8C100.7,72.7,95.1,73.5,88.9,71.6z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/elo.c3912620cbc1aea54816dba473a41ccc.svg";